import { map } from 'rxjs/operators';
import { Injector } from '@angular/core';

import { validateArrayType } from './utils/validate-array';
import { SgEntityFetchAdapter } from '../components/entity-select-auto-complete';
import { InstrumentsManagerApi, InstrumentsManagerApiClient } from '@sg/api/instruments-manager-api';

declare module '../components/entity-select-auto-complete/entity-select-fetch-store.service' {
  export interface SgEntitySelectEntityFetchMap {
    CompositeBbgId: {
      entity: InstrumentsManagerApi.InstrumentDto;
      query: InstrumentsManagerApi.InstrumentSearchParamsDto;
    };
  }
}

export class CompositeBbgIdApiToEntityFetcherLink implements SgEntityFetchAdapter<'CompositeBbgId'> {
  readonly key: 'CompositeBbgId' = 'CompositeBbgId';
  readonly metadata: {
    idField: keyof InstrumentsManagerApi.InstrumentDto;
    labelField: keyof InstrumentsManagerApi.InstrumentDto;
    queryField?: { field: keyof InstrumentsManagerApi.InstrumentSearchParamsDto; isArray?: boolean };
  } = {
    idField: 'data.currentIdentifiers.compositeBbgId' as keyof InstrumentsManagerApi.InstrumentDto,
    labelField: 'data.currentIdentifiers.compositeBbgId' as keyof InstrumentsManagerApi.InstrumentDto,
    queryField: { field: 'compositeBbgIds', isArray: true },
  };

  private readonly instrumentsManagerApi: InstrumentsManagerApiClient;

  constructor(injector: Injector) {
    this.instrumentsManagerApi = injector.get(InstrumentsManagerApiClient);
  }

  getEntity(compositeBbgIds: string[]) {
    const body: InstrumentsManagerApi.InstrumentSearchParamsDto = {
      compositeBbgIds: validateArrayType(compositeBbgIds),
    };

    return this.instrumentsManagerApi
      .instrumentsManagerControllerPostInstrumentsSearch({ body, pageNumber: 1 }, { observe: 'body' })
      .pipe(map((results) => results.rows));
  }

  findEntities(query?: InstrumentsManagerApi.InstrumentSearchParamsDto & { name: string[] }, pageNumber?: number) {
    const body: InstrumentsManagerApi.InstrumentSearchParamsDto = {};

    if (query) {
      Object.assign(body, query);
    }

    return this.instrumentsManagerApi
      .instrumentsManagerControllerPostInstrumentsSearch(
        { body, pageSize: 10, pageNumber: pageNumber ?? 1 },
        { observe: 'body' }
      )
      .pipe(
        map((result) => {
          return {
            data: result.rows ? result.rows : [],
            infiniteScrollInfo: { currentPage: result.paging.pageNumber, totalPages: result.paging.totalPages },
          };
        })
      );
  }
}
